import React, { useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import jwtDecode from "jwt-decode";
import { UserContext } from "./UserContext";

// Define the storage key for the Access Token
const ACCESS_TOKEN_KEY = "token";

const CallbackPage = () => {
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let accessToken = params.get("auth");
    let idToken = params.get("id_token");

    try {
      if (accessToken) {
        const tokenToCheck = idToken || accessToken;

        if (!tokenToCheck) {
          console.error("Missing primary token in redirect.");
          window.location.assign("/");
          return;
        }

        const decodedToken = jwtDecode(tokenToCheck);
        const tokenExp = new Date(decodedToken.exp * 1000);

        // If the token has already expired (unlikely in a redirect, but good check)
        if (new Date() > tokenExp)
        {
          console.warn("Received expired token on callback.");
          sessionStorage.removeItem(ACCESS_TOKEN_KEY);
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("auth");
          window.location.assign("/");
          return;
        }

        sessionStorage.setItem(ACCESS_TOKEN_KEY, tokenToCheck);
        sessionStorage.setItem("auth", "true");

        // Change in login requires full reload to fetch user and menus
        window.location.assign("/");
      }
    } catch (err) {
      console.error("ERROR during token processing or user query: ", err);
      // Clear session on fatal error and redirect to prevent loops
      sessionStorage.clear();
      window.location.assign("/");
    }
  }, [user, setUser]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    try {
      if (params.has("revoke")) {
        setUser({
          isPublic: true,
          isStaff: false,
          isSysAdmin: false,
          isPortalUser: false
        });
        sessionStorage.clear();
        window.location.assign("/");
      }
    } catch (err) {
      console.error("Error occured during logout: ", err);
    }
  }, [setUser]);

  return (
    <Row>
      <Col>
        <div className="utah-id-syncing">
          <p><em>Updating Login Status...</em></p>
        </div>
      </Col>
    </Row>
  );
};

export default CallbackPage;
